import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Timeline from '@material-ui/lab/Timeline';
import Typography from '@material-ui/core/Typography';
import { Box, Chip } from '@material-ui/core';
import data from './data';

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    justifyContent: 'center'
  },
  innerContainer: {
    width: '100%',
    textAlign: 'center',
    marginBottom: '1em'
  },
  chip: {
    backgroundColor: 'gold',
    marginRight: '1em',
    marginBottom: '1em',
    cursor: 'default',
    fontSize: '1rem'
  }
}));

export default function BasicTimeline() {
  const classes = useStyles();

  useEffect(() => {
    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  const renderTimeLineData = () => {
    return data.map((item, idx) => {
      return <TechStackItemData key={idx} data={item} />;
    });
  };

  const TechStackItemData = props => {
    const { title, items, icon, imgAltText } = props.data;
    return (
      <Box className={classes.container}>
        <Box className={classes.innerContainer}>
          {icon && <img src={icon} alt={imgAltText || ''} />}
          <Typography gutterBottom variant='h5' component='h3'>
            {title}
          </Typography>
          {items.map((item, idx) => {
            return <Chip className={classes.chip} key={idx} label={item} />;
          })}
        </Box>
      </Box>
    );
  };
  return <Timeline align='alternate'>{renderTimeLineData()}</Timeline>;
}
